import React, { Component, Fragment } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Home from "./../pages/Home";

// Activité
import Activite from "../pages/activite/Home";
import Planning from "../pages/activite/planning/Calendar";

import Survey from "../pages/survey/Home";
import InsertElement from "./../pages/survey/InsertElement";
import Phototheque from "../pages/activite/phototheque/Home";
import VisiteHome from "./../pages/activite/visit/Home";
import VisitePreview from "./../pages/activite/visit/Preview";
import ActiviteKpis from "./../pages/activite/kpi/Home";
// Base PDC
import BasePdc from "../pages/basepdc/Home.basepdc";
import PdcDetail from "../pages/basepdc/detailPdc/Home.detailpdc";
import ListPdcs from "../pages/basepdc/listpdcs/Home.listpdcs";
import RequestPdcs from "../pages/basepdc/requestsPdcs/Home.requestspdcs";
import Sectors from "../pages/metier/Sectors";
import Pdcs from "../pages/metier/Pdcs";
// Statistiques
import Stats from "./../modules/stats";
import StatsDownload from "./../modules/downloadstats";
import DashboardBi from "./../pages/dashboard/Home";
// Admin
import Admin from "../pages/admin/Home";
import Users from "../pages/admin/users/Home";
import Services from "../pages/admin/services/Services.home";
import Bonuses from "../pages/presence/premium/Home";

import Limits from "../pages/presence/premium/Limits";
import RegularBonuses from "../pages/presence/premium/RegularBonuses";
import Logs from "../pages/admin/logs/Home.log";
import LogPreview from "../pages/admin/logs/Preview.log";
// Imports
import Imports from "../pages/imports/Home";
import Modeles from "../pages/imports/imports/Modeles";
import Secto from "../pages/imports/imports/Secto";
import Kpis from "../pages/imports/imports/Kpis";
import Actions from "../pages/imports/imports/Actions";
import Metier from "../pages/imports/imports/Metier";
import Merch from "../pages/imports/imports/Merch";
import CommercialPeriods from "../pages/imports/imports/CommercialPeriods";
import Iocs from "../pages/imports/imports/Iocs";
import Networks from "../pages/imports/imports/Networks";
import Clients from "../pages/imports/imports/Clients";
import Typologies from "../pages/imports/imports/Typologies";
import Properties from "../pages/imports/imports/Properties";
import AuthRender from "../containers/AuthRender";
import { roles, SERVICES } from "../configs/constants";
import HomePoc from "../pages/admin/poc/Home.poc";

//Presence
import PresenceHome from "../pages/presence/Home";
import PresencePresence from "../pages/presence/presence/Home";
import PresenceConges from "../pages/presence/conges/Home";
import PresenceExpenseReports from "../pages/presence/expenseReports/Home";
import Accounting from "../pages/presence/expenseReports/Accounting.container";
import PresenceTransfers from "../pages/presence/transfers/Home";
import PresenceDetail from "../modules/presence/presence/PresenceDetail";
import BonusesTableContainer from "../pages/presence/premium/BonusesTable.container";
import BonusesHistoryContainer from "../pages/presence/premium/BonusesHistory.container";
import RibsContainer from "../pages/poc_rib/Ribs.container";
import DEVS from "../pages/devs/Devs.home";

import AccountingHome from "../pages/accounting/Home";
import AccountingMealPackage from "../pages/accounting/MealPackageUpdate.container";

import Prepare from "../pages/activite/Prepare";

import PrivateRoute from "./PrivateRoute";
import MobileAppVersionsContainer from "../pages/mobileAppVersions/MobileAppVersions.container";

import BackLogsContainer from "../pages/devs/backLogs/BackLogs.container";

import NextGenVisitsErrorContainer from "../pages/NextGenDashboard/NextGenVisitsError.container";
import NextGenVisitsMissingContainer from "../pages/NextGenDashboard/NextGenVisitsMissing.container";
import NextGenVisitsToProcessContainer from "../pages/NextGenDashboard/NextGenVisitsToProcess.container";
import NextGenDimPocContainer from "../pages/NextGenDashboard/NextGenDimPoc.container";

import BrandsContainer from "../containers/metier/referential/Brands.container";
import FamiliesContainer from "../containers/metier/referential/Families.container";
import RetailersContainer from "../containers/metier/referential/Retailers.container";
import RangesContainer from "../containers/metier/referential/Ranges.container";
import SectorsContainer from "../containers/metier/referential/Sectors.container";
import RefContainer from "../containers/metier/referential/Referential";
import LastMobileAppVersionsContainer from "../pages/mobileAppVersions/LastMobileAppVersions.container";
import AccountingExportsContainer from "../pages/accounting/AccountingExports.container";
import LuccaAttendancesContainer from "../pages/devs/lucca_attendances/LuccaAttendances.container";

import Sidely from "../pages/sidely/Sidely.home";
import ByTerryOrders from "../pages/sidely/ByTerryOrders.container";
import HaleonEvents from "../pages/sidely/HaleonEvents.container";
class MainContent extends Component {
  render() {
    return (
      <Fragment>
        <PrivateRoute service={SERVICES.Statistiques} path={`/stats`} component={props => <Stats {...props} />} />
        <PrivateRoute
          service={SERVICES.Statistiques}
          path={`/downloadstats`}
          component={props => <StatsDownload {...props} />}
        />
        <div className="p-content-page">
          <Route path={`/survey`} component={props => <Survey {...props} />} />
          <Router path={`/inserElement`} component={props => <InsertElement {...props} />} />
          <PrivateRoute
            service={SERVICES.KPI}
            path={`/activite/kpis`}
            component={props => <ActiviteKpis {...props} />}
          />
          <PrivateRoute
            service={SERVICES.Phototeque}
            path={`/phototheque`}
            component={props => <Phototheque {...props} />}
          />
          <PrivateRoute
            service={SERVICES.Visites}
            path={`/visit`}
            exact
            component={props => <VisiteHome {...props} />}
          />
          <PrivateRoute
            service={SERVICES.Visites}
            path={`/visit/preview/:id`}
            component={props => <VisitePreview {...props} />}
          />
          <Route path={`/`} exact component={props => <Home {...props} />} />
          <PrivateRoute
            oneServiceOf={[SERVICES.Planification, SERVICES.Formulaire, SERVICES.Phototeque, SERVICES.Visites]}
            exact
            path={`/activite`}
            component={props => <Activite {...props} />}
          />
          <PrivateRoute minRole={4} exact path={`/presence`} component={props => <PresenceHome {...props} />} />
          <PrivateRoute
            minRole={4}
            exact
            oneServiceOf={[SERVICES.Presence]}
            path={`/presence/presence`}
            component={props => <PresencePresence {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.Conges]}
            minRole={4}
            exact
            path={`/presence/conges`}
            component={props => <PresenceConges {...props} />}
          />
          <PrivateRoute
            minRole={4}
            exact
            path={`/accounting/expenseReports`}
            component={props => <PresenceExpenseReports {...props} />}
          />
          <PrivateRoute
            minRole={2}
            exact
            oneServiceOf={[SERVICES.Virement]}
            path={`/accounting/validation`}
            component={props => <Accounting {...props} />}
          />
          <PrivateRoute
            minRole={2}
            exact
            oneServiceOf={[SERVICES.Virement]}
            path={`/accounting/mealpackageupdate`}
            component={props => <AccountingMealPackage {...props} />}
          />
          <PrivateRoute
            minRole={2}
            exact
            oneServiceOf={[SERVICES.Virement]}
            path={`/accounting/exports`}
            component={props => <AccountingExportsContainer {...props} />}
          />
          <PrivateRoute
            minRole={2}
            oneServiceOf={[SERVICES.Virement]}
            exact
            path={`/accounting/transfers`}
            component={props => <PresenceTransfers {...props} />}
          />
          <PrivateRoute minRole={2} exact path={`/accounting/ribs`} component={props => <RibsContainer {...props} />} />
          <PrivateRoute
            minRole={1}
            exact
            path={`/mobile_app_versions`}
            component={props => <MobileAppVersionsContainer {...props} />}
          />
          <PrivateRoute
            minRole={1}
            exact
            path={`/lucca_attendances`}
            component={props => <LuccaAttendancesContainer {...props} />}
          />
          <PrivateRoute
            minRole={4}
            exact
            path={`/mobile`}
            component={props => <LastMobileAppVersionsContainer {...props} />}
          />
          <PrivateRoute minRole={1} exact path={`/backlogs`} component={props => <BackLogsContainer {...props} />} />
          <PrivateRoute
            oneServiceOf={[SERVICES.Primes]}
            minRole={2}
            exact
            path={`/presence/premium`}
            component={props => <Bonuses {...props} />}
          />
          <PrivateRoute
            path={`/presence/preview/:id`}
            component={props => {
              const dateFilters =
                props.location && props.location.search
                  ? props.location.search
                  : `?start_date=${moment()
                      .add(-1, "weeks")
                      .startOf("month")}&end_date=${moment()
                      .add(-1, "weeks")
                      .endOf("month")}`;

              return <PresenceDetail dateFilters={dateFilters} {...props} />;
            }}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.Primes]}
            minRole={3}
            exact
            path={`/bonuses`}
            component={props => <BonusesTableContainer {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.Primes]}
            minRole={3}
            exact
            path={`/presence/bonuseshistory`}
            component={props => <BonusesHistoryContainer {...props} />}
          />
          <PrivateRoute minRole={2} exact path={`/presence/limit`} component={props => <Limits {...props} />} />
          <PrivateRoute exact path={`/presence/regular`} component={props => <RegularBonuses {...props} />} />
          <PrivateRoute
            oneServiceOf={[SERVICES.PDC]}
            exact
            path={`/basepdc`}
            component={props => <BasePdc {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.PDC]}
            exact
            path={`/basepdc/detail/:id`}
            component={props => <PdcDetail {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.PDC]}
            exact
            path={`/basepdc/listpdcs`}
            component={props => <ListPdcs {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.PDC]}
            minRole={1}
            exact
            path={`/basepdc/requests`}
            component={props => <RequestPdcs {...props} />}
          />
          <PrivateRoute
            service={SERVICES.Secto}
            exact
            path={`/metier/sectors`}
            component={props => <Sectors {...props} />}
          />
          <PrivateRoute service={SERVICES.PDC} exact path={`/metier/pdcs`} component={props => <Pdcs {...props} />} />
          <PrivateRoute
            service={SERVICES.Planification}
            exact
            path={`/activite/planning/calendar`}
            component={props => <Planning {...props} />}
          />
          <PrivateRoute
            service={SERVICES.Planification}
            exact
            path={`/activite/prepare/:pdcId`}
            component={props => <Prepare {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.Privileges]}
            exact
            path={`/admin/home`}
            component={props => <Admin {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.Privileges]}
            exact
            path={`/devs`}
            component={props => <DEVS {...props} />}
          />{" "}
          <PrivateRoute
            oneServiceOf={[SERVICES.Privileges]}
            exact
            path={`/sidely`}
            component={props => <Sidely {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.Privileges]}
            exact
            path={`/byterry/commandes`}
            component={props => <ByTerryOrders {...props} />}
          />
             <PrivateRoute
            oneServiceOf={[SERVICES.Privileges]}
            exact
            path={`/haleon/event`}
            component={props => <HaleonEvents {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.KPI, SERVICES.Modele, SERVICES.Secto]}
            exact
            path={`/imports/home`}
            component={props => <Imports {...props} />}
          />
          <PrivateRoute exact path={`/admin/users`} component={props => <Users {...props} />} />
          <PrivateRoute exact minRole={1} path={`/admin/services`} component={props => <Services {...props} />} />
          <PrivateRoute minRole={1} exact path={`/logs`} component={props => <Logs {...props} />} />
          <PrivateRoute minRole={1} exact path={`/log/preview/:id`} component={props => <LogPreview {...props} />} />
          <PrivateRoute minRole={2} exact path={`/poc`} component={props => <HomePoc {...props} />} />
          <PrivateRoute
            service={SERVICES.Modele}
            exact
            path={`/imports/modeles`}
            component={props => <Modeles {...props} />}
          />
          <PrivateRoute
            service={SERVICES.Secto}
            exact
            path={`/imports/secteurs`}
            component={props => <Secto {...props} />}
          />
          <PrivateRoute minRole={1} exact path={`/imports/kpis`} component={props => <Kpis {...props} />} />
          <PrivateRoute
            minRole={roles.MANAGER}
            exact
            path={`/imports/actions`}
            component={props => <Actions {...props} />}
          />
          <PrivateRoute minRole={1} exact path={`/imports/metier`} component={props => <Metier {...props} />} />
          <PrivateRoute
            service={SERVICES.Modele}
            exact
            path={`/imports/merch`}
            component={props => <Merch {...props} />}
          />
          <PrivateRoute
            minRole={3}
            exact
            path={`/imports/commercial_periods`}
            component={props => <CommercialPeriods {...props} />}
          />
          <PrivateRoute minRole={1} exact path={`/imports/iocs`} component={props => <Iocs {...props} />} />
          <PrivateRoute minRole={1} exact path={`/imports/networks`} component={props => <Networks {...props} />} />
          <PrivateRoute minRole={1} exact path={`/imports/clients`} component={props => <Clients {...props} />} />
          <PrivateRoute minRole={1} exact path={`/imports/typologies`} component={props => <Typologies {...props} />} />
          <PrivateRoute minRole={1} exact path={`/imports/properties`} component={props => <Properties {...props} />} />
          <PrivateRoute
            exact
            minRole={5}
            service={SERVICES.Statistiques}
            path={`/dashboard`}
            component={props => <DashboardBi {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.Virement]}
            exact
            minRole={2}
            path={`/accounting`}
            component={props => <AccountingHome {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.Visites]}
            exact
            path={`/nextgen/visitserror`}
            component={props => <NextGenVisitsErrorContainer {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.Visites]}
            exact
            path={`/nextgen/visitsmissing`}
            component={props => <NextGenVisitsMissingContainer {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.Visites]}
            exact
            path={`/nextgen/visitstoprocess`}
            component={props => <NextGenVisitsToProcessContainer {...props} />}
          />
          <PrivateRoute
            oneServiceOf={[SERVICES.Visites]}
            exact
            path={`/nextgen/dimpoc`}
            component={props => <NextGenDimPocContainer {...props} />}
          />
          <PrivateRoute
            exact
            minRole={roles.MANAGER}
            path={`/ref/brands`}
            component={props => <BrandsContainer {...props} />}
          />
          <PrivateRoute
            exact
            minRole={roles.MANAGER}
            path={`/ref/families`}
            component={props => <FamiliesContainer {...props} />}
          />
          <PrivateRoute
            exact
            minRole={roles.MANAGER}
            path={`/ref/retailers`}
            component={props => <RetailersContainer {...props} />}
          />
          <PrivateRoute
            exact
            minRole={roles.MANAGER}
            path={`/ref/ranges`}
            component={props => <RangesContainer {...props} />}
          />
          <PrivateRoute
            exact
            minRole={roles.MANAGER}
            path={`/ref/sectors`}
            component={props => <SectorsContainer {...props} />}
          />
          <PrivateRoute exact minRole={roles.MANAGER} path={`/ref`} component={props => <RefContainer {...props} />} />
        </div>
      </Fragment>
    );
  }
}

export default withRouter(MainContent);



// WEBPACK FOOTER //
// src/routes/MainContent.js